/**
 * BlueCallToAction component
 * 
 * A specialized component for the blue call-to-action section with improved text visibility.
 * This component addresses the issue of text being hard to read against the blue background.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import './BlueCallToAction.css';

const BlueCallToAction = ({ 
  heading = "Ready to get started with Agent Nexus?",
  description = "Experience the power of intelligent automation for your organization.",
  primaryButtonText = "Start Free Trial",
  primaryButtonLink = "/signup",
  secondaryButtonText = "Request Demo",
  secondaryButtonLink = "/demo"
}) => {
  return (
    <div className="blue-cta-container">
      <div className="blue-cta-content">
        <h2 className="blue-cta-heading">{heading}</h2>
        <p className="blue-cta-description">{description}</p>
        <div className="blue-cta-buttons">
          <Link to={primaryButtonLink} className="blue-cta-button-primary">
            {primaryButtonText}
          </Link>
          <Link to={secondaryButtonLink} className="blue-cta-button-secondary">
            {secondaryButtonText}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlueCallToAction; 